import { executeManagedApiCaching } from '@ms/yammer-libs-api';

import type { PromiseThunkAction } from '../types';

import apiAction from './apiAction';
import type { ManagedApiActionOptions } from './types';

export interface CachedApiActionResult<TResponse> {
  readonly response: TResponse;
  readonly cacheHit: boolean | undefined;
}

const cachedApiAction =
  <TResponse>({
    request,
    caching,
    lifecycle,
    telemetry,
  }: ManagedApiActionOptions<TResponse>): PromiseThunkAction<CachedApiActionResult<TResponse>> =>
  async (dispatch) =>
    executeManagedApiCaching({
      request,
      caching,
      executeRequest: () => dispatch(apiAction<TResponse>(request, telemetry)),
      responseWritten: (response, cacheKey) => {
        if (caching?.strategy === 'ReadCacheAndRevalidateWithFulfill') {
          dispatch(lifecycle.fulfilled(response));
        }

        if (
          lifecycle.deferredFulfill &&
          (caching?.strategy === 'ReadCacheAndRevalidateWithDeferredFulfill' ||
            caching?.strategy === 'ReadCacheOrFetchWithTimeoutDeferredFulfill')
        ) {
          dispatch(lifecycle.deferredFulfill(response, cacheKey));
        }
      },
    });

export default cachedApiAction;
